import OfferPresenter from "presenters/OfferPresenter";

export const initialValues = {
  firstName: "",
  lastName: "",
  postalCode: "",
};

export const attributesToSubmit = (subscription) => {
  const {
    offer,
    payment: { firstName, lastName, postalCode, recurlyToken, lastFour, brand },
  } = subscription;

  return {
    data: {
      type: "recurly-billing-infos",
      id: OfferPresenter.id(offer),
      attributes: {
        token: recurlyToken,
        firstName,
        lastName,
        zip: postalCode,
        lastFour,
        cardType: brand,
      },
    },
  };
};
